import axios from "axios";
import { Constants } from "../utils/Constants";

export function login(data) {
    return axios.post(`${Constants.baseUrl}/auth`, data);
}

export function forgotPassword(email) {
    return axios.post(`${Constants.baseUrl}/forgot-password`, { email });
}

export function forgotPasswordCode(payload) {
    return axios.post(`${Constants.baseUrl}/forgot-password-code`, payload);
}

export function resetPassword(data) {
    return axios.post(`${Constants.baseUrl}/reset-password`, data);
}

export function primeiroAcesso(data) {
    return axios.post(`${Constants.baseUrl}/primeiro-acesso`, data);
}

export function cadastrar(payload) {
    return axios.post(`${Constants.baseUrl}/cadastrar`, payload);
}

export function reativarAcesso(data) {
    return axios.post(`${Constants.baseUrl}/reativar-acesso`, data);
}